import { TableLoader } from "../components/Loader";
import CommonViewMore from "./CommonViewMore";
import IconDisplay from "./IconDisPlay";
import NuDateFormat from "./NuDate";
import { GetAccess } from "./RolesandAccess";


function CommonTableView({data=[],fetcher,link,accessString,isLoading=true}) {
    const headers = [

        {
          label: "Name",
          width: "w-[47%]",
          isLeft:true,
        },
        {
          label: "Date",
          width: "w-[15%]",
        },
        {
          label: "Size",
          width: "w-[15%]",
        },
        {
          label: "View",
          width: "w-[20%]",
        },
        {
          label:"",
          width:"w-[3%]"
        }
      ];
  return (
    <div className="w-full h-[calc(100vh-190px)] relative overflow-y-auto ">
      <div className="bg-[#F1E0FF] w-full sticky top-0 z-10">
        <table className="w-full">
          <thead>
            <tr className="text-[13px] font-medium">
              {headers &&
                headers.map((header, i) => (
                  <th
                    className={`px-2 py-3 font-semibold ${header.isLeft?'text-left':'text-center'}  ${header.width}`}
                    key={i}
                  >
                    {header.label || " "}
                  </th>
                ))}
            </tr>
          </thead>
        </table>
      </div>
      <div className=" overflow-y-auto">
        <table className="w-full table-auto border-collapse">
          <tbody className="text-[13px] w-full">
            {
              isLoading == true ? (<>
                              <>
                  {[...Array(10)].map((_, index) => {
                    return <TableLoader key={index} header={headers} />;
                  })}
                </>
              </>):(<>
                {data?.data&&data?.data.map((item, i) => {
              return (
                <tr className="odd:bg-white even:bg-slate-50" key={i}>
                  <td className="w-[47%] px-2 py-3 text-left ">{item?.image_name||"-"}</td>
                  <td className="w-[15%] px-2 py-3 text-center "><NuDateFormat value={item?.modified_on} format="DD-MMM-YYYY" /> <small><NuDateFormat value={item?.modified_on} format="hh:mm" /></small></td>
                  <td className="w-[15%] px-2 py-3 text-center">{item?.file_size||""}</td>
                  <td className="w-[20%] px-2 py-2">
                    <div className='w-full  flex justify-center items-center'>
                      <IconDisplay data={item?.image_path} view={true} />
                    </div>
                  </td>
                  <td className='w-[3%] px-2 py-2'>
                    {
                      GetAccess(accessString) && <><CommonViewMore data={item} link={link} fetcher={fetcher} /></> 
                    } 
                  </td>
                </tr>
              );
            })}
              </>)
            }
          </tbody>
        </table>
      </div>
  </div>
  )
}

export default CommonTableView;